export const SRC_ERROR: string = 'Please select a valid source';

export const DES_ERROR: string = 'Please select a valid destination';

export const SRC_DES_SAME_ERROR: string = 'Source and destination cannot be same';

export const SRC_DES_EMPTY_ERROR: string = 'Source and destination cannot be empty';

export const DEP_ERROR: string = 'Please select a valid departure date';

export const ARR_ERROR: string = 'Please select a valid arrival date for your round trip';

export const INFANT_COUNT_ERROR: string = 'Number of infants cannot be more than adults';

export const MAX_PAX_ERROR: string = 'Maximum 9 passengers allowed';

export const REDIRECTING_TO_SRP_ERROR: string =
  'Confirmation failed with the airline. Redirecting to search page';

export const REDIRECTING_TO_SRP_ERROR_HEADING: string = 'Re-confirmation Failed With Airline...';

export const NO_BOOK_DATA_ERROR: string = 'Please try again later';

export const ERROR_HEADING: string = 'Booking Error...';

export const NO_RESULT = 'Sorry, we could not find any flights for this route.';

export const NO_RESULT_AFTER_FILTER =
  'Sorry! There are no flights available for the applied filters. Please reset your applied filters.';

export const SRP_DEFAULT_POPUP_ERROR: string = 'Something went wrong...';
